module.exports = __webpack_public_path__ + "img/evan-you.23e0c6a4.jpg";